import { Component, AfterViewInit, Renderer2, inject } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";
import { CookieComponent } from './cookie/cookie.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet, CookieComponent]
})

export class AppComponent implements AfterViewInit {
  title = 'SoulCastAngular';
  private router = inject(Router);
  private renderer = inject(Renderer2);

  constructor() {
    window.scrollTo(0, 0);
    gsap.registerPlugin(ScrollTrigger, TextPlugin);
    gsap.ticker.fps(24);
    gsap.ticker.lagSmoothing(1000, 20);
    this.router.events.pipe(takeUntilDestroyed()).subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
  ngAfterViewInit() {
    const loader = this.renderer.selectRootElement('#loader');
    this.renderer.setStyle(loader, 'display', 'none');
  }
}
